import React from "react";
import { getPortalLink } from "../../utils/portalLinks";
import { usePortalAccess } from "./PortalAccessProvider";

const shouldHandlePortalClick = (event) => {
  if (event.defaultPrevented) {
    return false;
  }

  if (event.button !== 0) {
    return false;
  }

  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
    return false;
  }

  return true;
};

function PortalEntryLink({ role, children, onClick, ...props }) {
  const { openPortal } = usePortalAccess();
  const href = getPortalLink(role);

  const handleClick = (event) => {
    onClick?.(event);

    if (!shouldHandlePortalClick(event)) {
      return;
    }

    event.preventDefault();
    openPortal(role);
  };

  return (
    <a {...props} href={href} onClick={handleClick}>
      {children}
    </a>
  );
}

export default PortalEntryLink;
